import ItemModel from "../item-model"
import ItemModelV2 from "../../item2/item-model";

// const debug = "ItemTreeAdapter"
const debug = false

export class ItemTreeAdapter {

    private itemModel: ItemModel

    constructor(itemModel: ItemModel) {
        this.itemModel  = itemModel
    }

    set parent(parent: ItemModel | undefined) {
        this.itemModel.treeParent = parent
    }

    get parent() {
        return this.itemModel.treeParent
    }

    set children(children: ItemModel[]) {
        this.itemModel.treeChildren = children
    }

    get children() {
        return this.itemModel.treeChildren
    }

    getAllChildren(openOnly: boolean = false) {
        let res : ItemModel[] = []

        _.map(this.children, (itemModel: ItemModel) => {
            if (itemModel && (!openOnly || itemModel.item.isOpen)) {
                res.push(itemModel)
                res = res.concat(itemModel.tree.getAllChildren(openOnly))
            }
        })

        return res
    }

    get numChildren() {
        return this.itemModel.numChildren
    }

    get allVisibleChildren(): ItemModelV2[] {
        let res : any[] = [];

        _.map(this.children, (itemModel: ItemModelV2) => {
            if (itemModel.isVisible) {
                res.push(itemModel)
                res = res.concat(itemModel.tree.allVisibleChildren)
            }
        })

        return res
    }

    get visibleTasks() {
        let res : any[] = [];

        _.map(this.children, (itemModel: ItemModelV2) => {
            if (itemModel.isVisible && itemModel.isTask) {
                res.push(itemModel)
            }

            if (itemModel.isNotHidden) {
                res = res.concat(itemModel.tree.visibleTasks)
            }
        })

        return res
    }

    get visibleTimeReports() {
        let res : any[] = [];

        _.map(this.children, (itemModel: ItemModelV2) => {
            if (itemModel.isVisible && itemModel.isTimeReport) {
                res.push(itemModel)
            }

            if (itemModel.isNotHidden) {
                res = res.concat(itemModel.tree.visibleTimeReports)
            }
        })

        return res
    }
}